export default function SectionHeader({ eyebrow, title, action }) {
  return (
    <div className="flex items-end justify-between gap-3 mb-5">
      <div>
        {eyebrow && (
          <p className="text-[10px] md:text-xs uppercase tracking-[0.25em] font-black text-primary">{eyebrow}</p>
        )}
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight mt-1">{title}</h2>
      </div>
      {action}
    </div>
  );
}
